import { CardContent, Grid } from "@mui/material";
import { MprcCard } from "components";
import { IconHistory } from "components/icons/IconHistory";
import { MprcButton } from "components/MprcButton";
import { AuditLogEntityType } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { AuditLogDialog } from "views/common/AuditLog/AuditLogDialog";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    entityType: AuditLogEntityType;
    entityKey?: string[] | null;
}

/////////////////////////////////////////////////////////////////////////////////

export const AuditLogHistoryFooter: React.FC<IPros> = ({ entityType, entityKey }) => {
    const [dialog, setDialog] = useState<any>();
    const { t } = useTranslation();

    return (
        <MprcCard>
            <CardContent>
                {dialog}
                <Grid container justifyContent="flex-start" alignItems="center" spacing={1}>
                    <Grid>
                        <MprcButton
                            onClick={
                                () => setDialog(
                                    <AuditLogDialog
                                        entityType={entityType}
                                        entityKey={entityKey}
                                        onClose={() => setDialog(null)}
                                    />
                                )
                            }
                            color="muted" disableRipple>
                            <IconHistory size="2x" fixedWidth />
                            <span>{t("EventLog.EventLogDialog.Title")}</span>
                        </MprcButton>
                    </Grid>
                </Grid>
            </CardContent>
        </MprcCard>
    );
};
